import React, { useEffect, useState } from 'react';
import Header from '../layouts/Header';
import Banner from '../components/service/Banner';
import Footer from '../layouts/Footer';
import JoinOurTeam from '../components/Home/JoinOurTeam';
import CommonDesign from '../components/service/commonDesign';
import WorkCulture from '../components/service/WorkCulture';
import Features from '../components/service/Features';
import Skills from '../components/service/Skills';
import { motion } from "motion/react";
import { Helmet } from "react-helmet";
const NearShore = () => {
  const [hasLoaded, setHasLoaded] = useState(false);
      const titleData = {
        service_name: "OUR NEARSHORE SERVICES",
        title: "Nearshore Excellence for Smarter Growth",
        content: "Volto connects you with top LATAM professionals for cost-effective, high-quality solutions that drive efficiency and growth."
      }
      const featureData = {
        service_name: "OUR NEARSHORE SERVICES",
        title: "Perfect For",
        list: [
          {
            icon: "/images/growing-business.svg",
            title: "Growing Businesses",
            content: "Growing Businesses seeking cost-effective solutions without compromising quality."
          },
          {
            icon: "/images/technology-companies.svg",
            title: "Technology Companies",
            content: "Tech Companies needing agile development and quick project turnarounds."
          },
          {
            icon: "/images/startups.svg",
            title: "Startups",
            content: "Startups looking to scale operations with flexible team models."
          },
          {
            icon: "/images/enterprises.svg",
            title: "Enterprises",
            content: "Enterprises aiming to streamline processes with nearshore support teams."
          },
          {
            icon: "/images/global-teams.svg",
            title: "Global Teams",
            content: "Global Teams that require seamless collaboration across time zones."
          },
        ] 
      }
      const skillData = {
        list: [
          {
           icon: "/images/volto-latam.svg",
           subheading: "VOLTO & LATAM",
           title: "Skilled Teams, Faster Outcomes.",
           content: "Volto’s nearshore expertise in LATAM connects businesses with top-tier talent from Mexico, Uruguay, and beyond. Our teams provide cost-effective, high-quality solutions that ensure seamless collaboration and faster results."
           }, 
           {
            icon: "/images/latam-advantage.svg",
            subheading: "LATAM ADVANTAGE",
            title: "Efficient, Cost-Effective, and Industry-Smart.",
            content: "Leverage LATAM’s skilled workforce to enhance your operations with professionals who understand your industry and work within your time zone. Our nearshore services reduce costs while maintaining the quality and efficiency your business needs."
            }, 
            {
              icon: "/images/capabilities.svg",
              subheading: "CAPABILITIES",
              title: "Accelerating Growth with Nearshore Excellence.",
              content: "From software development to customer support, our nearshore teams bring specialized expertise that accelerates innovation. With agile and scalable models, we ensure your business stays competitive in a fast-evolving market."
              }
        ]
      }
        
      useEffect(() => {
          window.scroll({
            top: 0,
            behavior: "smooth",
          });
          const timer = setTimeout(() => setHasLoaded(true), 100);
          return () => clearTimeout(timer);
        }, []);
      
 return(
  <motion.div
  initial={{ opacity: 0 }}
  animate={{ opacity: hasLoaded ? 1 : 0 }}
  transition={{ duration: 0.7 }}
>
<Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
    <div className='volto-homepage service  light-theme'>
    <Header />
    <Banner 
    mode="dark"
    bannerImg="/images/nearshore-banner.webp"
    title="Nearshore Services"
    main_content="Volto’s nearshore outsourcing brings skilled teams from neighboring countries closer to your business, ensuring seamless collaboration and efficient delivery."
    />
    <WorkCulture />
    <div className="linear-gradient pt-80">
    <CommonDesign data={titleData} />
    <Skills data={skillData} />
    </div>
    <Features data={featureData}/>
    <JoinOurTeam image={'/images/join-our-team.webp'}/>
    <Footer />
   </div>
   </motion.div>
 )
}
export default NearShore;